import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/icon_waiting_bank.svg'


const _hoisted_1 = { style: {"text-align":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createElementVNode("div", null, [
                        _createElementVNode("h3", { class: "headline mb-0" }, "Connexion bancaire")
                      ], -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_v_img, {
                          src: _imports_0,
                          "max-width": "30%"
                        }),
                        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                        _cache[3] || (_cache[3] = _createElementVNode("p", null, " Votre compte bancaire est en cours de synchronisation, merci de patienter... ", -1)),
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (acc) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: acc.id
                            }, _toDisplayString(acc.name), 1))
                          }), 128))
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}